import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionComponentBase } from '../../../ProductSectionComponentBase';
import { ProductSectionComponent } from '../../product-section';
import { ProductCrossReferencesComponent } from '../product-cross-references';

@Component({
  selector: 'ideal-product-section-cross-references',
  imports: [ProductCrossReferencesComponent, ProductSectionComponent],
  templateUrl: './product-section-cross-references.component.html',
  styleUrl: './product-section-cross-references.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasContent() ? undefined : "none"',
  },
})
export class ProductSectionCrossReferencesComponent extends ProductSectionComponentBase {}
